export const SET_LOGOS = 'set_logos';
export const SET_HEADER_LOGO = 'set_header_logo';
export const SET_FOOTER_LOGO = 'set_footer_logo';
export const SET_ADMIN_LOGO = 'set_admin_logo';

export const INITIAL_LOGOS_STATE = {
	logos: {
		headerLogo: '',
		footerLogo: '',
		adminLogo: ''
	}
};
